import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import { LocalStorageService } from '@upr-web-primer/storage';
import { get } from '@upr-web-primer/udx-utils';
import { Observable } from 'rxjs';
import { CommonUtilityService } from './services/common-utility.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private readonly guestsService: MsGuestsService,
    private readonly common: CommonUtilityService,
    private readonly localStorage: LocalStorageService,
    @Inject('AppRoutes') private readonly appRoutes: any,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const id_token_hint = get(route.queryParams, 'id_token_hint', '');
    const guestId = this.localStorage.getItem('LOGGEDIN_GUEST_ID') || '';
    const oidcLoginToken = this.localStorage.getItem('OIDC_ID_TOKEN') || '';
    const oauthLoginId = this.localStorage.getItem('OAUTH_LOGIN_GID') || '';

    if (
      !id_token_hint &&
      !guestId &&
      !oidcLoginToken &&
      !oauthLoginId &&
      !this.guestsService.helper.isAuth()
    ) {
      this.common.changeRoute(this.appRoutes.LOGIN);
      return false;
    }
    return true;
  }
}
